import { SvgIcon } from '@mui/material';

import type * as React from 'react';
import type { BaseIconProps } from '../types';

export const BrokerOutlinedIcon: React.FC<BaseIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 30 40" fillRule="evenodd" stroke="none" {...props}>
      <path
        d="M15.0035 13.4503C18.3212 13.4503 21.0107 10.7609 21.0107 7.44319C21.0107 4.12553 18.3212 1.43604 15.0035 1.43604C11.6858 1.43604 8.99634 4.12553 8.99634 7.44319C8.99634 10.7609 11.6858 13.4503 15.0035 13.4503Z"
        stroke="currentColor"
        strokeWidth="1.20414"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M7.91107 15.6143C3.89478 15.6143 2.82332 20.4532 2.82332 20.4532C2.05975 23.6272 1.47813 26.8423 1.0813 30.0826C1.0813 32.8961 3.68052 32.5366 6.99171 32.4882"
        stroke="currentColor"
        strokeWidth="1.20414"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M22.0959 15.6143C26.1122 15.6143 27.1837 20.4532 27.1837 20.4532C27.9427 23.6278 28.522 26.8427 28.9188 30.0826C28.9188 32.8477 25.7874 32.4882 23.0154 32.4882"
        stroke="currentColor"
        strokeWidth="1.20414"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M18.1004 35.4258L16.5243 17.9573C16.5146 17.812 16.4525 17.6752 16.3495 17.5722C16.2465 17.4692 16.1097 17.4072 15.9644 17.3975H14.0426C13.8968 17.4057 13.7592 17.4673 13.6559 17.5706C13.5526 17.6739 13.491 17.8115 13.4827 17.9573L11.9066 35.4258C11.8911 35.5374 11.9017 35.6512 11.9377 35.7579C11.9737 35.8647 12.034 35.9616 12.114 36.0411L14.644 38.419C14.7413 38.5108 14.8697 38.5627 15.0035 38.5642C15.1352 38.5624 15.2612 38.5104 15.3561 38.419L17.893 36.0411C17.973 35.9616 18.0333 35.8647 18.0693 35.7579C18.1053 35.6512 18.116 35.5374 18.1004 35.4258V35.4258Z"
        stroke="currentColor"
        strokeWidth="1.20414"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </SvgIcon>
  );
};
